import { Actions, Type } from './context.actions';
import { IContextState, initialState } from './context.state';

export function contextReducer(
  state: IContextState = initialState,
  action: Actions,
): IContextState {
  switch (action.type) {
    case Type.SET_DEVICE_SUCCESS:
      return {
        ...state,
        device: action.payload,
      };
    case Type.SET_LANDING_VIEW_OFF:
      return {
        ...state,
        core: { ...state.core, isLanding: false },
      };
    default:
      return state;
  }
}
